const ContentSlice = () => ({
  edge_to_edge: 'Yes',
  hide_pips_on_mobile: 'No',
  id: null,
  items: null,
  pad_bottom: 'Yes',
  sliceId: 0,
  type: null,
  typography: 'sans-serif',
});

export default ContentSlice;
